import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ValidKey } from '../../core/models/key.model';

export interface DomainAccess {
  pharmacies: boolean;
  entreprises: boolean;
  offres: boolean;
  gouvernement: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LicenceService {
  private accessState = new BehaviorSubject<DomainAccess>({
    pharmacies: false,
    entreprises: false,
    offres: false,
    gouvernement: false
  });

  accessState$ = this.accessState.asObservable();

  constructor() {
    // Charger l'état initial depuis le localStorage
    const savedState = localStorage.getItem('domainAccess');
    if (savedState) {
      this.accessState.next(JSON.parse(savedState));
    }
  }

  verifyLicenceKey(key: ValidKey): boolean {
    const currentState = this.accessState.value;
    currentState.pharmacies = true;
    currentState.entreprises = true;
    currentState.offres = true;
    currentState.gouvernement = true;
    
    this.accessState.next(currentState);
    localStorage.setItem('domainAccess', JSON.stringify(currentState));
    return true;
  }

  isDomainAccessible(domain: keyof DomainAccess): boolean {
    return this.accessState.value[domain];
  }
} 